var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Form",
    {
      ref: "loginForm",
      attrs: { model: _vm.form, rules: _vm.rules },
      nativeOn: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "FormItem",
        { attrs: { prop: "userName" } },
        [
          _c(
            "Input",
            {
              attrs: { placeholder: "请输入用户名" },
              model: {
                value: _vm.form.userName,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "userName", $$v)
                },
                expression: "form.userName",
              },
            },
            [
              _c(
                "span",
                { attrs: { slot: "prepend" }, slot: "prepend" },
                [_c("Icon", { attrs: { size: 16, type: "ios-person" } })],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "FormItem",
        { attrs: { prop: "password" } },
        [
          _c(
            "Input",
            {
              attrs: { type: "password", placeholder: "请输入密码" },
              model: {
                value: _vm.form.password,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "password", $$v)
                },
                expression: "form.password",
              },
            },
            [
              _c(
                "span",
                { attrs: { slot: "prepend" }, slot: "prepend" },
                [_c("Icon", { attrs: { size: 14, type: "md-lock" } })],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "FormItem",
        [
          _c(
            "Button",
            {
              attrs: { loading: _vm.loading, type: "primary", long: "" },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("登录")]
          ),
        ],
        1
      ),
      _c(
        "FormItem",
        {
          staticStyle: {
            display: "flex",
            "align-items": "flex-end",
            "justify-content": "flex-end",
          },
        },
        [
          _c(
            "Button",
            {
              staticStyle: {
                "background-color": "#ffff",
                border: "none",
                color: "#2d8cf0",
                "font-size": "14px",
                padding: "0px",
              },
              attrs: {
                to: "https://oldseedadmin.brighten.cn:4443",
                target: "_blank",
                long: "",
                type: "primary",
              },
            },
            [_vm._v("前往旧版")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }